import { Injectable } from '@angular/core';
import {
  Resolve,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  Router,
} from '@angular/router';
import { BaseService } from '@kodit/core/services';
import {
  GetNewIzlaznaFakturaForUplataQuery,
  IzlaznaFakturaDto,
  IzlazneFaktureClient,
} from '@kodit/core/data-api';
import { Observable } from 'rxjs';
import { catchError, finalize, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class IzlaznaFakturaZaUplatuResolver
  extends BaseService
  implements Resolve<IzlaznaFakturaDto> {
  constructor(private _client: IzlazneFaktureClient, private _router: Router) {
    super();
  }

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<IzlaznaFakturaDto>
    | Promise<IzlaznaFakturaDto>
    | IzlaznaFakturaDto
    | null {
    return this._client
      .getNewForUplata(
        new GetNewIzlaznaFakturaForUplataQuery({
          strankaId: this._router.getCurrentNavigation().extras.state.strankaId,
          datumPrometa: this._router.getCurrentNavigation().extras.state
            .datumPrometa,
          datumIzdavanja: this._router.getCurrentNavigation().extras.state
            .datumIzdavanja,
          uplataId: this._router.getCurrentNavigation().extras.state
            .transakcijaIzvodaId,
        })
      )
      .pipe(
        map((res) => res.data),
        catchError(this.handleError),
        finalize(() => {
          //this._configService.setIsBusy = false;
        })
      );
  }
}
